import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import HandlesProps from '../common/handlesProps'
// import ReactPasswordStrength from 'react-password-strength'

export default class PasswordConfirmInputs extends HandlesProps(PureComponent) {
  static propTypes = {
    onChange: PropTypes.func
  };

  constructor(props) {
    super(props);
    this._mounted = true
    this.state = {
      password: '',
      confirmPassword: '',
      ReactPasswordStrength: false
    }
    this.handlePassword = ::this.handlePassword
  }

  handlePassword(info) {
    const ok = info.password.length > 4
    this.setState({
      password: ok && info.password,
    })
  }

  /* componentDidMount() {
   *   this._mounted = true
   *   import('react-password-strength').then(module => {
   *     if (this._mounted) {
   *       this.setState({
   *         ReactPasswordStrength: module.default
   *       })
   *     }
   *   })
   * }
   * componentWillUnmount() {
   *   this._mounted = false
   * }*/
  componentDidUpdate(prevProps, prevState) {
    const { onChange } = this.props
    const { password, confirmPassword } = this.state
    if (prevState.password !== password || prevState.confirmPassword !== confirmPassword) {
      const ok = password !== '' && confirmPassword === password && password.length > 5
      if (onChange) {
        onChange({
          password: ok && password,
          ok
        })
      }
    }
  }

  render() {
    const { password, confirmPassword } = this.state
    /* if (!ReactPasswordStrength) {
     *   return(<div />)
     * }*/
    return (
      <div className="component-password-confirm-inputs">
        <h4>Password</h4>
        {/* <ReactPasswordStrength changeCallback={this.handlePassword} /> */}
        <input type="password" onChange={this.handleChangeProp('password')} defaultValue={password} />
        <h4>Confirm Password</h4>
        <input type="password" onChange={this.handleChangeProp('confirmPassword')} defaultValue={this.state.confirmPassword} />
        {password !== '' && confirmPassword !== '' && password !== confirmPassword ? <div className="error">Passwords do not match</div> : '' }
        {password !== '' && password.length < 6 ? <div className="error">Password is too short</div> : '' }
      </div>
    );
  }
}

PasswordConfirmInputs.displayName = 'PasswordConfirmInputs'

PasswordConfirmInputs.displayName = 'PasswordConfirmInputs'

PasswordConfirmInputs.displayName = 'PasswordConfirmInputs'

PasswordConfirmInputs.displayName = 'PasswordConfirmInputs'

PasswordConfirmInputs.displayName = 'PasswordConfirmInputs'

PasswordConfirmInputs.displayName = 'PasswordConfirmInputs'

PasswordConfirmInputs.displayName = 'PasswordConfirmInputs'
